import { Modal, Button, Result } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

const ConfirmationModal = ({ modalState, setModalState }) => {
    return (
        <Modal
            open={modalState === 'successConfirm'}
            onCancel={() => setModalState('closed')}
            centered={true}
            footer={[
                <Button key="close" type="primary" onClick={() => setModalState('closed')}>
                    Close
                </Button>
            ]}
        >
            <Result
                icon={<CheckCircleFilled style={{ color: '#52c41a', fontSize: '72px' }} />}
                title="Catalogue Created Successfully"
                subTitle="Your new catalogue has been created and is ready to use."
            />
        </Modal>
    )
}

export default ConfirmationModal;